/**
 * Web logout: wipe localStorage for session/private data while keeping keys used for
 * appearance (ThemeContext) and persisted UI prefs (zustand `ui-storage`).
 */

export const LOCAL_STORAGE_KEYS_PRESERVED_ON_WEB_LOGOUT = Object.freeze([
  'ui-storage',
  'theme',
  'accentBackgroundColor',
  'accentTextColor',
]);

export function snapshotPreserveKeysThenClear(localStorageLike) {
  try {
    const preserved = {};
    for (const key of LOCAL_STORAGE_KEYS_PRESERVED_ON_WEB_LOGOUT) {
      const val = localStorageLike.getItem(key);
      if (val != null) preserved[key] = val;
    }
    localStorageLike.clear();
    for (const key of LOCAL_STORAGE_KEYS_PRESERVED_ON_WEB_LOGOUT) {
      if (Object.prototype.hasOwnProperty.call(preserved, key)) {
        localStorageLike.setItem(key, preserved[key]);
      }
    }
  } catch (e) {
    console.warn('Logout: could not selectively clear localStorage', e);
  }
}
